/** Утилиты для разбора llm_extras шота (сезоны / модалка деталей). */

export function normalizePromptSpaces(s: string) {
  return s.replace(/\s+/g, " ").trim()
}

function shotLlmString(v: unknown): string | null {
  return typeof v === "string" && v.trim() ? v.trim() : null
}

function shotLlmStringArray(v: unknown): string[] {
  if (!Array.isArray(v)) return []
  return v.map((x) => (typeof x === "string" ? x.trim() : String(x).trim())).filter(Boolean)
}

/** true, если поле не задано — опорный кадр уходит в видео по умолчанию. */
export function sendStoryboardFrameFromExtras(extras: Record<string, unknown> | null | undefined): boolean {
  if (!extras || extras.video_send_storyboard_frame === undefined) return true
  return Boolean(extras.video_send_storyboard_frame)
}

/** Склейка полей LLM из llm_extras, если user_visible ещё не отражает развёрнутый ответ. */
export function shotStructuredPromptBlock(extras: Record<string, unknown> | null | undefined): string | null {
  if (!extras || typeof extras !== "object") return null
  const description = shotLlmString(extras.description)
  const visualDetails = shotLlmStringArray(extras.visual_details)
  const vdBlock = visualDetails.length ? visualDetails.join("; ") : null
  const camera = shotLlmString(extras.camera)
  const visual = shotLlmString(extras.visual)
  const action = shotLlmString(extras.action)
  const parts = [description, vdBlock, camera, visual, action].filter(Boolean) as string[]
  const uniq = [...new Set(parts)]
  return uniq.length ? uniq.join("\n\n") : null
}
